import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// Config
import { IMAGE_BASE_URL, CARD_POSTER_SIZE } from '../../config';
// Helpers
import { getYear, formatRating, initials } from '../../helpers';
import { ratingColor } from '../RatingRing';
// Styles
import { Wrapper, Poster, Fallback, Badge, Meta } from './MovieCard.styles';

const MovieCard = ({ movie, index }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const year = getYear(movie.release_date);

  return (
    <Wrapper style={{ animationDelay: `${Math.min(index % 20, 12) * 35}ms` }}>
      <Link to={`/${movie.id}`} aria-label={`${movie.title}${year ? ` (${year})` : ''}`}>
        <Poster $loaded={loaded || failed || !movie.poster_path}>
          {movie.poster_path && !failed ? (
            <img
              src={`${IMAGE_BASE_URL}${CARD_POSTER_SIZE}${movie.poster_path}`}
              alt=''
              loading='lazy'
              onLoad={() => setLoaded(true)}
              onError={() => setFailed(true)}
            />
          ) : (
            <Fallback>
              <span>{initials(movie.title)}</span>
              <small>{movie.title}</small>
            </Fallback>
          )}
          <Badge style={{ '--dot': ratingColor(movie.vote_average) }}>
            <i />
            {formatRating(movie.vote_average)}
          </Badge>
        </Poster>
        <Meta>
          <h3>{movie.title}</h3>
          <p>
            {year || 'TBA'}
            {movie.original_language && movie.original_language !== 'en' && (
              <span>{movie.original_language.toUpperCase()}</span>
            )}
          </p>
        </Meta>
      </Link>
    </Wrapper>
  );
};

MovieCard.propTypes = {
  movie: PropTypes.object.isRequired,
  index: PropTypes.number
};

export default MovieCard;
